module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 1e-05","quantity":0},{"color":"#9dc4b5","label":" 1e-05- 0.29942","quantity":0.00299},{"color":"#e6efc3","label":" 0.29942- 0.81992","quantity":0.0082},{"color":"#ffe89e","label":" 0.81992- 1.6097","quantity":0.0161},{"color":"#f5af7f","label":" 1.6097- 2.9402","quantity":0.0294},{"color":"#ed6d32","label":" 2.9402- 16.68536","quantity":0.16685}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/cfxssl_raster/wheat_MME_1981_2016_lcr_80.json
// module id = kGw7
// module chunks = 171